import { useState, useCallback } from 'react';

export function useTableSortState(initialKey: string | null = null) {
  const [sortKey, setSortKey] = useState<string | null>(initialKey);
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('asc');

  const toggleSort = useCallback((key: string) => {
    setSortKey((prev) => {
      if (prev === key) {
        setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
        return prev;
      }
      setSortDir('asc');
      return key;
    });
  }, []);

  const setSort = useCallback((key: string | null, dir: 'asc' | 'desc') => {
    setSortKey(key);
    setSortDir(dir);
  }, []);

  return { sortKey, sortDir, toggleSort, setSort };
}
